import { clsx } from 'clsx'

export const ChatListItemLoading = () => {
  return (
    <div className="p-1">
      <div
        className={clsx(
          'relative px-2 py-3 bg-surface hover:bg-surface-hovered transition-all duration-300 rounded-base cursor-pointer',
          'group flex flex-1 gap-x-2 items-center overflow-hidden',
        )}
      >
        <div className="w-10 h-10 bg-skeleton rounded-base animate-pulse"></div>
        <div className="flex-grow min-w-0">
          <div className="flex space-s-2 items-center min-w-0">
            <div className="flex items-center grow truncate">
              <div className="h-4 bg-skeleton rounded-base w-32 animate-pulse"></div>
            </div>
            <div className="h-4 bg-skeleton rounded-base" />
          </div>
          <div className="flex items-center overflow-hidden mt-1 min-w-0 relative gap-x-4">
            <div className="min-w-0 grow">
              <div className="h-4 bg-skeleton rounded-base w-20 animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
